(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("locale/locale_nb", [], factory);
	else if(typeof exports === 'object')
		exports["locale/locale_nb"] = factory();
	else
		root["locale/locale_nb"] = factory();
})(window, function() {
return 